import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, PhoneIcon, MailIcon, InstagramIcon, ArrowUpIcon } from 'lucide-react';
import { BrandTiktok } from './icons/BrandTiktok';
import { openingHours } from '../data/businessInfo';
export const Footer = () => {
  const [isShining, setIsShining] = useState(false);
  // Create a subtle shine effect every 5-6 seconds
  useEffect(() => {
    const shineInterval = setInterval(() => {
      setIsShining(true);
      // Reset the shine effect after it completes
      setTimeout(() => {
        setIsShining(false);
      }, 1500); // Duration of shine animation
    }, 5500); // Interval between shine effects (5.5 seconds)
    return () => clearInterval(shineInterval);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-[#0a0a0a] text-[#CCCCCC] py-16 border-t border-[#222222] relative" data-id="element-174" data-mp="2eya05yj9stox">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#222222] to-transparent" data-id="element-175" data-mp="2evxat0b6nh1u"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176" data-mp="3gaz3l7v1stm7">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-177" data-mp="3gcjvsqtw40gw">
          {/* Logo and info */}
          <div data-id="element-178" data-mp="3v5n6ce92ddy4">
            <div className="mb-8" data-id="element-179" data-mp="3q8n1g6nyah8l">
              <Link to="/" data-id="element-180" data-mp="3q7lmvs7q7cm4">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6P9doWbYb8UgxtfPvK6o5M/BK-Customs-Logo-DEF-01-1973x2048.png" alt="BKCustoms Logo" className="h-20 w-auto" data-id="element-181" data-mp="3q7bvc0718xeb" />
              </Link>
            </div>
            <p className="mb-6 text-sm max-w-xs" data-id="element-182" data-mp="3232hadx3j13">
              Premium car customization voor jouw unieke rijervaring.
              Vakmanschap en kwaliteit sinds 2010.
            </p>
            <div className="flex space-x-4" data-id="element-183" data-mp="cvtom8mknhdm">
              <a href="https://www.instagram.com/bk.customs36/" target="_blank" rel="noopener noreferrer" className="bg-[#121212] p-3 rounded-full hover:bg-[#D6281F] transition-colors duration-300 group" data-id="element-184" data-mp="qt051wjtp3zo">
                <InstagramIcon size={20} className="text-white group-hover:text-white" data-id="element-185" data-mp="tvw7qgxe1ffz" />
              </a>
              <a href="https://www.tiktok.com/@bk.customs36" target="_blank" rel="noopener noreferrer" className="bg-[#121212] p-3 rounded-full hover:bg-[#D6281F] transition-colors duration-300 group" data-id="element-186" data-mp="yv93xsa5fyv8">
                <BrandTiktok size={20} className="text-white group-hover:text-white" data-id="element-187" data-mp="18l2dknqqe3wu" />
              </a>
            </div>
          </div>
          {/* Contact info */}
          <div data-id="element-188" data-mp="1hkfe2qwvni5f">
            <h3 className="text-xl font-semibold text-white mb-6" data-id="element-189" data-mp="1hjw888ki4k7r">Contact</h3>
            <div className="space-y-4" data-id="element-190" data-mp="1mk1rp1gmb0er">
              <div className="flex items-start" data-id="element-191" data-mp="1ml3gs9ugxnfh">
                <MapPinIcon size={20} className="mr-3 mt-1 flex-shrink-0 text-[#D6281F]" data-id="element-192" data-mp="1riv5kuztgtfg" />
                <span className="text-sm" data-id="element-193" data-mp="1rgiqcplg0x63">
                  Microfoonstraat 36
                  <br data-id="element-194" data-mp="3oczot9hfgf5i" />
                  1322 BN Almere
                </span>
              </div>
              <div className="flex items-center" data-id="element-195" data-mp="3tai0v8qqrahq">
                <PhoneIcon size={20} className="mr-3 flex-shrink-0 text-[#D6281F]" data-id="element-196" data-mp="2afn7ky1dnbtf" />
                <a href="tel:+31627888306" className="text-sm hover:text-white transition-colors duration-300" data-id="element-197" data-mp="25onczzfqd5u3">
                  +31 (0)6 278 88 306
                </a>
              </div>
              <div className="flex items-center" data-id="element-198" data-mp="1wnp9rjd492ck">
                <MailIcon size={20} className="mr-3 flex-shrink-0 text-[#D6281F]" data-id="element-199" data-mp="1wp0996zj3nxv" />
                <a href="mailto:info@bkcustoms.nl" className="text-sm hover:text-white transition-colors duration-300" data-id="element-200" data-mp="2tcy8so6kkfbi">
                  info@bkcustoms.nl
                </a>
              </div>
            </div>
            <div className="mt-8" data-id="element-201" data-mp="2kc019vwx9po6">
              <h4 className="text-white font-medium mb-2" data-id="element-202" data-mp="2kf4f7l06vzs1">Openingstijden</h4>
              <p className="text-sm" data-id="element-203" data-mp="2fdowhzlhi5ct">{openingHours.lines[0]}</p>
              <p className="text-sm" data-id="element-204" data-mp="18yee2gamhy5a">{openingHours.lines[1]}</p>
            </div>
          </div>
          {/* Navigation */}
          <div data-id="element-205" data-mp="13xgmjd3q3rr4">
            <h3 className="text-xl font-semibold text-white mb-6" data-id="element-206" data-mp="13xqh7dzpqn35">Navigatie</h3>
            <div className="grid grid-cols-2 gap-2" data-id="element-207" data-mp="2ruy08cwf3wwo">
              <ul className="space-y-2" data-id="element-208" data-mp="2wm7mr4mo6k4c">
                <li data-id="element-209" data-mp="2wn994594yt1d">
                  <Link to="/" className="text-sm hover:text-[#D6281F] transition-colors duration-300" data-id="element-210" data-mp="2wokcw52l00sh">
                    Home
                  </Link>
                </li>
                <li data-id="element-211" data-mp="2nuxm6td8dnq5">
                  <Link to="/diensten" className="text-sm hover:text-[#D6281F] transition-colors duration-300" data-id="element-212" data-mp="2nue49cnkyzc4">
                    Diensten
                  </Link>
                </li>
                <li data-id="element-213" data-mp="3fksacmpcr7d8">
                  <Link to="/over-ons" className="text-sm hover:text-[#D6281F] transition-colors duration-300" data-id="element-214" data-mp="3fj7nlj9a4spx">
                    Over ons
                  </Link>
                </li>
              </ul>
              <ul className="space-y-2" data-id="element-215" data-mp="36mgloq81qjnf">
                <li data-id="element-216" data-mp="1q647bc2nj1rv">
                  <Link to="/contact" className="text-sm hover:text-[#D6281F] transition-colors duration-300" data-id="element-217" data-mp="1q5m0xmm9z768">
                    Contact
                  </Link>
                </li>
                <li data-id="element-218" data-mp="1nkwjqbiyhghz">
                  <Link to="/veelgestelde-vragen-faq" className="text-sm hover:text-[#D6281F] transition-colors duration-300" data-id="element-219" data-mp="1nkedcm2kxlwc">
                    FAQ
                  </Link>
                </li>
                <li data-id="element-220" data-mp="1wm455t0dimun">
                  <Link to="/algemene-voorwaarden" className="text-sm hover:text-[#D6281F] transition-colors duration-300" data-id="element-221" data-mp="1wkjiepkaw87c">
                    Algemene voorwaarden
                  </Link>
                </li>
              </ul>
            </div>
            <button onClick={scrollToTop} className="mt-8 inline-flex items-center bg-[#121212] hover:bg-[#D6281F] text-white px-4 py-2 rounded-md transition-colors duration-300" data-id="element-222" data-mp="zx68g592ceuu">
              <span className="mr-2 text-sm" data-id="element-223" data-mp="18xbeaaylz56w">Terug naar boven</span>
              <ArrowUpIcon size={16} data-id="element-224" data-mp="18uyq3g29byle" />
            </button>
          </div>
        </div>
        <div className="border-t border-[#222222] mt-12 pt-8 text-center text-xs" data-id="element-225" data-mp="l5nwqjn8l6ha">
          <p className="mb-2" data-id="element-226" data-mp="g7me1ztq396c">
            &copy; {new Date().getFullYear()} BKCustoms. Alle rechten
            voorbehouden.
          </p>
          <div className="text-[#999999] flex flex-wrap justify-center items-center gap-2" data-id="element-227" data-mp="2g8sv79zryz6q">
            <Link to="/privacybeleid" className="text-[#D6281F] hover:text-white transition-colors duration-300" data-id="element-228" data-mp="2l7dn8m4vick3">
              Privacybeleid
            </Link>
            <span className="text-[#444444]" data-id="element-229" data-mp="2uy8clzdf1s9r">|</span>
            <Link to="/algemene-voorwaarden" className="text-[#D6281F] hover:text-white transition-colors duration-300" data-id="element-230" data-mp="1xbrit43w5wsr">
              Algemene voorwaarden
            </Link>
            <span className="text-[#444444]" data-id="element-231" data-mp="22cyomxmh4lws">|</span>
            <a href="https://www.radux.nl" target="_blank" rel="noopener noreferrer" className="relative text-[#666666] hover:text-white text-[10px] transition-all duration-300 overflow-hidden group" data-id="element-232" data-mp="279pbc3ssafr6">
              <span className="relative z-10" data-id="element-233" data-mp="3io2n4aa9j4qu">
                Powered by Radux Digital Agency
              </span>
              {/* Subtle shine effect */}
              <span className={`absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full ${isShining ? 'animate-shine' : ''}`} style={{
              transform: isShining ? 'translateX(200%)' : 'translateX(-100%)',
              transition: 'transform 1.5s ease-in-out'
            }} data-id="element-234" data-mp="1b3ckqgu6bqa2"></span>
            </a>
          </div>
        </div>
      </div>
    </footer>;
};